module.exports = __webpack_public_path__ + "static/media/volar-platinum.e587c4bf.png";